import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  ADD_QUESTIONNAIRE,
  EDIT_QUESTIONNAIRE,
  VIEW_QUESTIONNAIRE,
  LIST_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE,
  ADD_QUESTIONNAIRE_TEXT,
  EDIT_QUESTIONNAIRE_TEXT,
  VIEW_QUESTIONNAIRE_TEXT,
  LIST_QUESTIONNAIRE_TEXT,
  DELETE_QUESTIONNAIRE_TEXT
} from "./actionTypes"
import { questionnaireSuccess, questionnaireError } from "./actions"

import {
  onAddQuestionnaire,
  onEditQuestionnaire,
  onViewQuestionnaire,
  onListQuestionnaire,
  onDeleteQuestionnaire,
  onAddQuestionnaireText,
  onEditQuestionnaireText,
  onListQuestionnaireText,
  onViewQuestionnaireText,
  onDeleteQuestionnaireText
} from "helpers/backend_api_helper";

// add questionnaire
function* addQuestionnaire({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddQuestionnaire, data);
    yield put(questionnaireSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// edit questionnaire
function* editQuestionnaire({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditQuestionnaire, data, id);
    yield put(questionnaireSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// list questionnaire
function* listQuestionnaire({ payload: { data, callback } }) {
  try {
    const response = yield call(onListQuestionnaire, data);
    yield put(questionnaireSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// view questionnaire
function* viewQuestionnaire({ payload: { data, history } }) {
  try {
    const response = yield call(onViewQuestionnaire, data);
    yield put(questionnaireSuccess(response));

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// delete questionnaire
function* deleteQuestionnaire({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteQuestionnaire, data);
    yield put(questionnaireSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add questionnaire
function* addAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onAddQuestionnaireText, data);
    yield put(questionnaireSuccess(response));
    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message);
    callback && callback(error?.response);
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// edit questionnaire
function* editQuestionnaireText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditQuestionnaireText, data, id);
    yield put(questionnaireSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// list questionnaire
function* listQuestionnaireText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListQuestionnaireText, data, id);
    yield put(questionnaireSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// view questionnaire
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewQuestionnaireText, data);
    yield put(questionnaireSuccess(response));

  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}

// delete questionnaire
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteQuestionnaireText, data);
    yield put(questionnaireSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(questionnaireError(error?.response?.data?.message || "Server Error"));
  }
}



function* QuestionnaireSaga() {
  yield takeEvery(ADD_QUESTIONNAIRE, addQuestionnaire);
  yield takeEvery(EDIT_QUESTIONNAIRE, editQuestionnaire);
  yield takeEvery(LIST_QUESTIONNAIRE, listQuestionnaire);
  yield takeEvery(VIEW_QUESTIONNAIRE, viewQuestionnaire);
  yield takeEvery(DELETE_QUESTIONNAIRE, deleteQuestionnaire);

  // text
  yield takeEvery(ADD_QUESTIONNAIRE_TEXT, addAspirationText);
  yield takeEvery(EDIT_QUESTIONNAIRE_TEXT, editQuestionnaireText);
  yield takeEvery(LIST_QUESTIONNAIRE_TEXT, listQuestionnaireText);
  yield takeEvery(VIEW_QUESTIONNAIRE_TEXT, viewAspirationText);
  yield takeEvery(DELETE_QUESTIONNAIRE_TEXT, deleteAspirationText);
}

export default QuestionnaireSaga;

